<template>
  <component
    :is="preview ? 'div' : 'textarea'"
    v-bind="filteredAttrs"
    :value="modelValue"
    @input="(e) => $emit('update:modelValue', e.target.value)"
    class="input-textarea"
    autocomplete="off"
    :class="{'input-textarea--preview': preview, 'input-textarea--error': error}"
  >{{modelValue}}</component>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      preview: {
        type: Boolean,
        default: false,
      },
      error: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      filteredAttrs() {
        // Filter out event listeners that start with 'on'
        const attrs = {};
        for (const key in this.$attrs) {
          if (!key.startsWith('on')) {
            attrs[key] = this.$attrs[key];
          }
        }
        return attrs;
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .input-textarea {
    @include reset-input(true);
    display: block;
    width: 100%;
    min-height: r(24 * 6 + 16);
    padding: r(8);
    border: solid r(1) transparent;
    border-bottom-color: $color-black;
    resize: vertical;
    white-space: pre-line;
    background-color: #f7f7f7;
    transition: background-color 0.2s, border-color 0.2s;

    &:focus {
      border-bottom-color: $color-green-2025;
    }

    &--error,
    &--error:focus {
      background-color: $color-red-light;
      border-bottom-color: $color-red;
    }

    &--preview,
    &:disabled {
      border-bottom-color: transparent;
    }
    @media print {
      border-bottom-color: transparent;
    }
  }
</style>
